import { FunctionComponent, useCallback, useState } from 'react';

import { useNavigate } from 'react-router-dom';

import { TagModel } from 'models';

import { apiClient } from 'core/api/globals';
import { useEvent } from 'core/hooks';
import { NotificationsService } from 'core/notifications';

import { TagsRoutes } from '../routes';
// Import the service for data conversion
import { TagsEditService } from '../services';
// Import the type used by the form
import { EditFormValues } from '../types';
// Assuming routes are defined here
// Assuming TagsFieldTemplateFormProps is defined in or exported alongside TagsFieldTemplateForm
import { TagsFieldTemplateForm } from './TagsFieldTemplateForm';

// TODO: Fetch actual parent tags if needed for the form's dropdown/selector
const MOCK_PARENT_TAGS: TagModel[] = [];

export const AddTagsFieldTemplatePage: FunctionComponent = () => {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Define the initial empty tag structure (removed 'level' and 'isSelectable')
  const initialTag: TagModel = {
    id: 0,
    name: '',
    parentTagId: null,
    description: null,
    active: true,
    tagFieldOption: null,
    required: false,
    multipleSelection: false,
    children: [],
  };

  // Use EditFormValues type for the handler parameter
  const handleSubmit = useEvent(async (formData: EditFormValues) => {
    setIsSubmitting(true);
    try {
      // Convert form data to TagModel using the service
      const tagModelPayload = TagsEditService.copyFormToModel(0, formData); // Use ID 0 for adding

      // Use the correct add/update method
      await apiClient.tagsClient.addUpdateTags(tagModelPayload);
      NotificationsService.displaySuccess('Tag added successfully');
      navigate(TagsRoutes.HOME); // Navigate back to grid on success
    } catch (error) {
      NotificationsService.displayError('Failed to add tag');
      console.error('Add tag error:', error);
      setIsSubmitting(false); // Keep form enabled on error
    }
  });

  return (
    <TagsFieldTemplateForm
      tag={initialTag} // Pass the initial empty tag
      parentTags={MOCK_PARENT_TAGS} // Pass fetched or mock parent tags
      onSubmit={handleSubmit}
      isSubmitting={isSubmitting}
    />
  );
};
